<ion-header *ngIf="isShowHeader">
	<ion-toolbar class="ion-justify-content-center ion-align-items-center">
		<div class="main-header">
			<span class="back-text lightBlue ion-padding" *ngIf="currentRoute != '/areas'">BackOffice</span>
			<span class="f-24" *ngIf="currentRoute == '/areas'">Areas Management</span>
			<span class="back-text lightBlue ion-padding" *ngIf="gamePageName != ''">{{ gamePageName }}
				<span *ngIf="gamePagesCount > 1">[ switch ]</span>
			</span>
			<div class="alignmet-avatar">
				<img class="ion-float-right ion-padding" src="/assets/imgs/avatar-image.png"
					 (click)="showLogoutPopover()" />
				<div class="message-alignment">
					<div class="ion-float-right ion-text-end">👋 Welcome Back,</div>
					<!--<span class="ion-float-right green-text">More than 10+ new updates</span>-->
					<span class="ion-float-right green-text">HomeaZZon is here to help!</span>
				</div>
				<div class="ion-float-right ion-padding">
					<div class="user-info">
						<span class="avatar-name">
							{{ userDetails?.Name || '' }}
						</span>
						<span class="avatar-name">
							{{userDetails?.PrivateLabeler?.Name || ''}}
						</span>
					</div>
				</div>
			</div>
		</div>
	</ion-toolbar>
</ion-header>